import {GlobalLoadingIndicator} from "../../../ui/decorators/global.loading.indicator.decorator";
import {Component, Injector, ViewChild, ViewEncapsulation} from "@angular/core";
import {BaseComponent} from "../../../ui/components/base/base.component";
import {Municipio} from "../../../../classes/municipio";
import {LoginService} from "../../../core/services/login.service";
import {ReCaptchaComponent} from "../../../ui/components/captcha/re.captcha.component";
import {RpsFilter} from "../../filters/rps.filter";
import {PublicRpsService} from "../../services/public.rps.service";
import {RpsTO} from "../../../../classes/to/rps.to";
import {DocumentoPipe} from "../../../core/pipes/documento.pipe";

@Component({
  selector: 'consulta-rps-page',
  templateUrl: './consulta.rps.page.component.html',
  styleUrls: ['./consulta.rps.page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConsultaRpsPageComponent extends BaseComponent {

  @ViewChild("reCaptchaComponent")
  reCaptchaComponent: ReCaptchaComponent;

  constructor(private injector: Injector,
              private rpsService: PublicRpsService,
              private loginService: LoginService) {
    super(injector)
  }

  municipio: Municipio;

  municipiosCliente: Municipio[] = [];

  resultList: RpsTO[];

  rpsFilter: RpsFilter = new RpsFilter();

  ngOnInit(): void {
    this.buscaMunicipiosCliente();
  }

  @GlobalLoadingIndicator()
  buscaMunicipiosCliente() {
    return this.of(this.loginService.buscarListaMunicipioCliente(), municipios => {
      this.municipiosCliente = municipios;
      if(this.reCaptchaComponent){
        this.reCaptchaComponent.init();
      }
    });
  }

  @GlobalLoadingIndicator()
  acionaPesquisar() {
    this.clearErrorMessages();
    this.resultList = [];
    if (!this.rpsFilter.captcha) {
      this.addErrorMessage("Captcha obrigatório.");
      return;
    }

    if(!this.municipio){
      this.addErrorMessage("Selecione o município.");
    }

    if(!this.rpsFilter.documento){
      this.addErrorMessage("Informe o CPF para ser consultado.");
    }

    if(!this.rpsFilter.numeroRps){
      this.addErrorMessage("Informe o número do recibo");
    }

    if(!this.hasErrorMessages()){
      this.rpsFilter.idMunicipio = this.municipio.id;
      return this.of(this.rpsService.buscarRps(this.rpsFilter), result => {
        if(result){
          this.resultList.push(result);
        }
        this.reCaptchaComponent.reset();
      }, error => {
        this.handleError(error);
        this.reCaptchaComponent.reset();
      });
    }
  }

  url(evento: any) {
    return '/public/documentos?senha=' + evento.codigoVerificador + "&data="+ this.replacePlusFromString(evento.validador);
  }

  documentoPrestadorChange(documento: string) {
    this.rpsFilter.documento = this.formataDocumento(documento);
  }

  documentoTomadorChange(documento: string) {
    this.rpsFilter.documentoTomador = this.formataDocumento(documento);
  }

  private formataDocumento(documento: string): string{
    if(documento && documento.trim().length>0){
      let documentoPipe = new DocumentoPipe();
      return documentoPipe.transform(documento);
    }
    return documento;
  }

}
